export const getIsAdmin = ({
  currentSession,
  flagCurrentSessionContext,
}: {
  currentSession: any;
  flagCurrentSessionContext: boolean;
}) =>
  flagCurrentSessionContext
    ? currentSession.checkAdminDualAccount && currentSession.networkAdmin
    : null;
